// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "BadgeTooltip" + "." + "31b5cb0b5f76f96e" + ".js"
}